module.exports = __webpack_public_path__ + "static/media/help.4d40b8a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/help.svg
// module id = 248
// module chunks = 0